import axios from "axios";

export default class AxiosService {
  constructor() {
    let service = axios.create();
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    this.service = service;
  }

  handleSuccess(response) {

    if (response.request) {
      if (response.request.responseURL) {
        if (response.request.responseURL.includes("login")) {
            window.location = "/oauth2/authorization/entra";
        }
      }
    }

    return response;
  }

  // maybe to use it later... Better way is to handle errors in a service... Not in such a generic way...
  handleError(error) {
    // if (error.response === undefined) {
    //   console.log("tikkie axiosservice!");
    //   window.location = "/oauth2/authorization/okta";

    //   return Promise.reject(error);
    // }
    switch (error.response.status) {
      case 403:
        window.location = "/";
        break;
      case 404:
        this.redirectTo(document, "/404");
        break;
      default:
        this.redirectTo(document, "/500");
        break;
    }
    return Promise.reject(error);
  }

  redirectTo(document, path) {
    document.location = path;
  }

  get(path, config) {
    return this.service.get(path, config);
    // return this.service.get(path, {
    //   crossDomain: true
    // });
  }

  delete(path, payload) {
    return this.service.delete(path, payload);
  }

  post(path, payload, config) {

    return this.service.post(path, payload, config);
  }

  patch(path, payload) {
    return this.service.patch(path, payload);
  }

  put(path, payload, config) {
    return this.service.put(path, payload, config);
  }
}